export default __webpack_public_path__ + "static/media/handprint-10-11-page.904f442c.png";